export { DigitalMenuConfigProvider, useDigitalMenuConfig } from "./DigitalMenuConfigContext";
